import { FC, ReactNode } from 'react';
import { Security } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { BrowserRouter } from 'react-router-dom';
import {
  oktaVariables,
  restoreOriginalUri,
} from '../utils/OkataUtils/oktaAuthUtils';

interface IAuthProvider {
  children: ReactNode;
}

const AuthProvider: FC<IAuthProvider> = ({ children }) => {
  const oktaClientAuth = new OktaAuth(oktaVariables);

  return (
    <BrowserRouter>
      <Security
        oktaAuth={oktaClientAuth}
        restoreOriginalUri={restoreOriginalUri}
      >
        {children}
      </Security>
    </BrowserRouter>
  );
};

export default AuthProvider;
